import { GoogleLogin } from "@react-oauth/google";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { AUTH } from "../../Router/paths";
import envelope_ico from "../../assets/images/envelope.png";
import key_ico from "../../assets/images/key.png";
import login_img from "../../assets/images/login-img.png";
import login_logo from "../../assets/images/login-logo.png";
import { axiosInstance } from "../../config/https";
import { useLoader } from "../../context/LoaderContext";

function Login() {
  const { startLoader, stopLoader } = useLoader();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleInputChange = (e, func) => {
    func(e.target.value);
  };

  const handleLogin = (e) => {
    e.preventDefault();
    startLoader();
    if (email === "" || password === "")
      return toast.error("Email Password is required");
    const data = {
      email: email,
      password: password,
    };
    axiosInstance
      .post("/api/user/login/", data)
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          localStorage.setItem("token", Data.token.access);
          localStorage.setItem("user", JSON.stringify(Data.user));
          toast.success(Data.msg);
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  const onSuccess = (resp) => {
    console.log(resp);
    startLoader();
    axiosInstance
      .post("/social_auth/google/", {
        auth_token: resp.credential,
      })
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          localStorage.setItem("token", Data.tokens.access);
          localStorage.setItem("user", JSON.stringify(Data.user));
          toast.success(Data.msg);
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  const onError = (resp) => console.log("google error", resp);

  return (
    <>
      <div
        className="login-sec pc-p-4"
        style={{
          background:
            "url('../assets/login-bg.png') no-repeat center center / cover",
        }}
      >
        <div className="container-fluid px-5">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-12">
              <div className="side-img">
                <img src={login_img} alt="Login" />
              </div>
            </div>
            <div className="col-lg-6 col-md-6 col-12">
              <div className="login-form">
                <div className="login-logo">
                  <img src={login_logo} alt="Logo" />
                </div>
                <div className="login-content">
                  <h4>Log in to get started</h4>
                  <h5 className="text-center">Connect by Social Networks</h5>
                  <ul className="list-inline text-center">
                    <li className="list-inline-item">
                      <GoogleLogin onSuccess={onSuccess} onError={onError} />
                    </li>
                  </ul>
                  <span>OR</span>
                </div>
                <form action="" className="main-form" onSubmit={handleLogin}>
                  <label htmlFor="">Email Address</label>
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control"
                      value={email}
                      onChange={(e) => handleInputChange(e, setEmail)}
                      placeholder="Enter Your Email"
                    />
                    <img src={envelope_ico} alt="Envelope" />
                  </div>
                  <label htmlFor="">Password</label>
                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control"
                      value={password}
                      onChange={(e) => handleInputChange(e, setPassword)}
                      placeholder="Enter Your Password"
                    />
                    <img src={key_ico} alt="Key" />
                  </div>
                  <ul className="form-btns">
                    <li>
                      <Link to={AUTH.forgotPassword}>Forgot Password?</Link>
                    </li>
                    <li>
                      <Link to={AUTH.signup} className="color-primary">
                        Create an account
                      </Link>
                    </li>
                  </ul>
                  <div className="text-center">
                    <button className="primary-btn secondary-bg px-5">
                      Log in
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
